import { ReactNode } from 'react';
import { IEnumItem } from '../PageLayout/context/LayoutContext';
import { filterEmptyValue } from './utils';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
/**
 * 单个枚举翻译
 * @param enumName 枚举名称
 * @param enumItem 枚举数组
 */
export function renderEnumName(
  enumName: any,
  enumItem: IEnumItem[],
): ReactNode {
  if (enumName === undefined || !enumItem) return TABLE_COLUMN_EMPTY;
  const findItem = enumItem.find(v => v.value === enumName);
  if (!findItem) return filterEmptyValue(enumName);
  return findItem.label;
}
/**
 * 多个枚举翻译
 * @param enumName 枚举名称
 * @param enumItem 枚举数组
 */
export function renderEnumNames(
  enumNames: any | any[],
  enumItem: IEnumItem[],
  separator: string = '、',
): ReactNode {
  if (enumNames === undefined || !enumItem) return TABLE_COLUMN_EMPTY;
  if (Array.isArray(enumNames)) {
    const result: ReactNode[] = [];
    enumNames.forEach(v => {
      result.push(renderEnumName(v, enumItem));
    });
    return result.join(separator);
  } else {
    return renderEnumName(enumNames, enumItem);
  }
}
